import { render, staticRenderFns } from "./ProjectInternal.vue?vue&type=template&id=991db9c2&scoped=true"
import script from "./ProjectInternal.vue?vue&type=script&lang=js"
export * from "./ProjectInternal.vue?vue&type=script&lang=js"
import style0 from "./ProjectInternal.vue?vue&type=style&index=0&id=991db9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991db9c2",
  null
  
)

export default component.exports